import { Bloc } from "@kernel/frontend-react-app";
import { PremeetingState, defaultPremeetingState } from "./PremeetingState";
import { ActiveDevice, RoomNameService } from "@domain";
import { LocalVideoManager, StartMediaStreamInteractor } from "../local";

export type PremeetingBlocInteractors = {
  startMediaStream: StartMediaStreamInteractor;
};

export class PremeetingBloc
  extends Bloc<PremeetingState>
  implements LocalVideoManager
{
  public constructor(private interactors: PremeetingBlocInteractors) {
    super(defaultPremeetingState);
  }

  public async change(
    videoElement: HTMLVideoElement,
    type: string,
    selectedDevice?: ActiveDevice,
    _roomName?: string,
    _displayName?: string,
    isScreenSharing: boolean = false
  ): Promise<void> {
    if (!selectedDevice) {
      throw new Error("SelectedDevice is not set");
    }
    const premeetingStream = await this.interactors.startMediaStream.execute({
      selectedDevice,
      videoElement: videoElement,
      isScreenSource: isScreenSharing
    });
    this.changeState({
      ...this.state,
      premeetingStream
    });
  }

  public stop(type: "audio" | "video"): void {
    if (this.state.premeetingStream === null) return;
    this.state.premeetingStream.stop(type);
  }

  public restart(type: "audio" | "video"): void {
    if (this.state.premeetingStream === null) return;
    this.state.premeetingStream.restart(type);
  }

  public hasTrackEnabled(type: "audio" | "video"): boolean {
    if (this.state.premeetingStream === null) return false;
    return this.state.premeetingStream.hasEnabledTrack(type);
  }

  public isUnsafeRoomName(roomName: string): boolean {
    return RoomNameService.isUnsafeRoomName(roomName);
  }

  public static create(): PremeetingBloc {
    const interactors = {
      startMediaStream: StartMediaStreamInteractor.create()
    };
    return new PremeetingBloc(interactors);
  }
}
